export default "__VITE_ASSET__D$PcQQoo__"